import { z } from 'zod';

// One shipment's money, as the Financial pages show it. The server builds these from the Serb Mind vault
// (the tracker's cost and selling price, Data/costs.csv, Data/invoices.csv, Data/documents.csv).

export const FinRecordSchema = z.object({
  srb: z.string(),
  currency: z.enum(['USD', 'EUR', 'JOD']),
  /** what the customer pays */
  price: z.number(),
  /** what the overseas agent charges; null until the agent's cost is known */
  agent: z.number().nullable(),
  /** what the shipping line or airline charges (0 when it is inside the agent's all-in price) */
  carrier: z.number().nullable(),
  /** trucking, clearance and other local costs SERB paid (0 when the customer's own broker cleared it) */
  local: z.number().nullable(),
  status: z.enum(['Pending Invoice', 'Invoiced', 'Partially Paid', 'Paid']),
  /** the customer invoice, once there is one */
  invoiceNo: z.string(),
  /** the invoice (or confirmation) date, this many days before today */
  daysAgo: z.number(),
  /** days until the customer invoice is due (negative = overdue) */
  dueInDays: z.number(),
  /** how much of the customer invoice has been paid, 0 to 1 */
  paidShare: z.number(),
  agentInvoiceNo: z.string(),
  agentDueInDays: z.number(),
  agentPaid: z.boolean(),
  /** has Ibraheem checked the agent's invoice against the quote? */
  /** is there an invoice from the agent? Only then does SERB owe it. */
  agentInvoiced: z.boolean().optional(),
  agentVerified: z.boolean(),
  jcs: z.enum(['Approved', 'Awaiting approval', 'Not started']),
  /** the shipment is booked or arrived, so its price and profit count even before an invoice is recorded */
  won: z.boolean().optional(),
});

export type FinRecord = z.infer<typeof FinRecordSchema>;
export type InvoiceStatus = FinRecord['status'];
export type JcsStatus = FinRecord['jcs'];
